import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import NumbersEnableFlowsForm from './NumbersEnableFlowsForm'
import { linkTwilioToAapt, createNumber, getNumbers } from '../Numbers.actions'

const formName = 'numbersEnableFlows'

const stateToProps = ({ form }) => ({
  form: formName,
  formData: get(form, `${formName}.values`, {}),
})

const dispatchToProps = {
  linkTwilioToAapt,
  createNumber,
  getNumbers,
}

export default connect(stateToProps, dispatchToProps)(reduxForm()(NumbersEnableFlowsForm))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEnableFlowsForm/NumbersEnableFlowsForm.container.js